import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ApiTokenType, useAuth } from '../context/AuthContext';
import { useQueryParams } from './useQueryParams';

export const useLogin = () => {
  const { redirectTo } = useQueryParams();
  const { login } = useAuth();
  const history = useHistory();

  return useCallback(
    (apiToken: string, tokenType: ApiTokenType) => {
      login(apiToken, tokenType);
      history.push(redirectTo ?? '/');
    },
    [history, login, redirectTo],
  );
};
